import { render } from "./CustomerSatisfactionView.vue?vue&type=template&id=009d87aa&scoped=true"
import script from "./CustomerSatisfactionView.vue?vue&type=script&lang=js"
export * from "./CustomerSatisfactionView.vue?vue&type=script&lang=js"

import "./CustomerSatisfactionView.vue?vue&type=style&index=0&id=009d87aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009d87aa"]])

export default __exports__